import React from 'react';
import { useAsync } from 'react-use';
import { fetchArticleAttribute } from '../../API/ArticleAttributeApi';
import { UserReward } from '../../Types/UserReward';
import LoadingIcon from '../LoadingIcon';
import Media from '../Media';
import RewardCard, { RewardCardRarity } from '../RewardCard';

interface AttributeCardRewardProps {
  reward: UserReward;
}

const AttributeCardReward: React.FC<AttributeCardRewardProps> = ({
  reward,
}) => {
  const attributeId = reward.rewardData.attributeId as string;
  const { value: attribute, loading } = useAsync(async () => {
    return await fetchArticleAttribute(attributeId);
  }, [attributeId]);

  if (loading || !attribute) {
    return (
      <div className="w-[140px] h-[200px] rounded-lg bg-gray-50 border-2 border-gray-300 flex items-center justify-center">
        <LoadingIcon size={3} />
      </div>
    );
  }

  const attributeContent = (
    <div className="w-20 h-20 rounded-full bg-gray-50 border border-gray-200 flex items-center justify-center mb-2 overflow-hidden">
      {attribute.image && (
        <Media
          src={[
            attribute.image.thumbnailUrl,
            attribute.image.compressedUrl,
            attribute.image.originalUrl,
            attribute.image.sharedStorageUrl,
          ]}
          alt={attribute.title}
          className="w-full h-full object-cover"
        />
      )}
    </div>
  );

  return (
    <RewardCard
      reward={reward}
      title={attribute.title}
      description={attribute.description}
      rarity={RewardCardRarity.Rare}
      content={attributeContent}
      type={attribute.type}
    />
  );
};

export default AttributeCardReward;
